import Vue from 'vue'

export class Connection {
  constructor({ endpoint, queryPath, dispatch }) {
    this.endpoint = endpoint
    this.url = endpoint + queryPath
    this.ref = null
    this.dispatch = dispatch(this)
  }

  connect() {
    return this.getRef().then(() => Promise.resolve())
  }

  // get data from endpoint
  get({ query, ...options }) {
    return Vue.http.get(this.url, {
      params: { ref: this.ref, ...query.reduce(), ...options }
    })
    .then(response => response.json())
    .then(data => {
      // if the response contains an api error, the ref has changed
      if (data.error) {
        console.info(data.error)
        return this.getRef().then(() => this.get({ query, ...options }))
      }

      if (options.pageSize && options.pageSize < data.results.length) {
        data.results = data.results.slice(0, options.pageSize)
      }

      return Promise.resolve(data)
    })
  }

  // get the master ref from the endpoint
  getRef() {
    return Vue.http.get(this.endpoint).then(response => response.json()).then(({ refs }) => {
      this.ref = refs.find(ref => ref.isMasterRef).ref
      return Promise.resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/classes/Connection.js